import defaultSettings from '../settings.json';
const initialState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {}
  },
  channels: [],
  products: [],
  previewDraft: {},
  mchSets: []
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return { ...state,
          settings
        };
      }

    case 'update-userInfo':
      {
        const {
          userInfo = initialState.userInfo,
          userLoading
        } = action.payload;
        return { ...state,
          userLoading,
          userInfo
        };
      }

    case 'update-sets':
      {
        //跟新结算数据主要是费率
        const {
          sets
        } = action.payload;
        return { ...state,
          mchSets: sets
        };
      }

    case 'get-configs':
      {
        const {
          products,
          channels,
          vbanks,
          joinTips,
          transCost,
          eCommerces,
          smsChannel
        } = action.payload;
        return { ...state,
          products,
          channels,
          vbanks,
          joinTips,
          transCost,
          eCommerces,
          smsChannel
        };
      }

    case 'preview-draft':
      {
        const {
          previewDraft
        } = action.payload;
        return { ...state,
          previewDraft
        };
      }

    default:
      return state;
  }
}